import React from 'react';
import ReportUtils from "../../../../../../../utils/report-utils.js";
import InfoGrid from "../../../../../../../components/info-grid/info-grid.jsx";

const IndividualArticles = ({item}) => {
    const articles = item.articles ?? []
    if (!articles.length || !articles) return null;

    return (
        <>
            { articles && (
                <section className="space-y-4!">
                    <div className={`text-[16px] mt-7! font-semibold text-[#4F4F4F] mb-2 print:break-after-avoid!`}>
                        Artigos indiciados
                    </div>

                    { articles.map((item, index) => {

                        const info = [
                            {
                                subTitle: `${index === 0 && articles.length === 1 ? " " : `Artigo ${index + 1}`}`,
                                className: `${index === 0 && articles.length === 1 ? "mt-[-25px]" : ""}`,
                                subTitleClassName: `${articles.length > 1 ? 'text-[15px]!' : ''}`,
                                items: [
                                    {
                                        label: "Data",
                                        value: ReportUtils.formatDateOnly(item?.date) ?? "",
                                    },
                                    {
                                        label: "Boletim",
                                        value: item?.bo ?? "",
                                    },
                                    {
                                        label: "Natureza",
                                        value: item?.article ?? ""
                                    }
                                ]
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'pb-3 px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default IndividualArticles;